import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-submaster',
  templateUrl: './submaster.component.html',
  styleUrls: ['./submaster.component.css']
})
export class SubmasterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/submaster/submaster.component.ts